module.exports = __webpack_public_path__ + "static/media/dispatch_systemmoduleC-icon6.6f275e9d.png";